import { render, staticRenderFns } from "./prescriber.vue?vue&type=template&id=3dc27446&scoped=true&"
import script from "./prescriber.vue?vue&type=script&lang=js&"
export * from "./prescriber.vue?vue&type=script&lang=js&"
import style0 from "./prescriber.vue?vue&type=style&index=0&id=3dc27446&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dc27446",
  null
  
)

export default component.exports